import { TeachingAidType } from "@hulanbv/ssllow-packages";
import { dictionary } from "./i18n/dictionary";

export const teachingAidTypeLabels: Record<TeachingAidType, string> = {
  [TeachingAidType.IMAGE]: dictionary.image,
  [TeachingAidType.VIDEO]: dictionary.video,
  [TeachingAidType.LINK]: dictionary.url,
  [TeachingAidType.TEXT]: dictionary.text,
};
